<template>
  <span fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Cadastro de Usuários</h2>
        <v-spacer></v-spacer>
        <v-btn @click="onNewButtonClick()" small color="primary">Novo</v-btn>
      </v-card-title>
      <v-card-text>
        <e-data-table
          :headers="headers"
          :items="usuarios"
          :total="total"
          @refresh="getAll"
          @edit="editItem"
          @delete="deleteItem"
        ></e-data-table>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </span>
</template>
<script>
import usuarioService from '@/services/usuario'
import EDataTable from '@/components/EDataTable'
import { showError, showConfirm, retPermissao } from '@/utils'

export default {
  name: 'usuario',
  components: {
    EDataTable
  },
  data () {
    return {
      usuarios: [],
      total: 0,
      headers: [
        { text: 'Nome', value: 'nome', sortable: false },
        { text: 'Ativo', value: 'ativo', sortable: false }
      ],
      valid: true,
      rules: {
        nome: [v => !!v || 'Campo Requerido'],
        ativo: [v => !!v || 'Campo Requerido']
      },
      buttonSaveLoadingVisible: false
    }
  },

  methods: {
    async getAll (page, search) {
      try {
        const result = search === '' ? await usuarioService.getAll(page) : await usuarioService.getByNome(search, page)
        this.total = result._meta.total_items
        this.usuarios = result.data
      } catch (error) {
        this.usuarios = []
        showError(error)
      }
    },
    async deleteItem (item) {
      var ret = retPermissao('Usuários', 'excluir')
      if (ret === true) {
        showConfirm(`Tem certeza que deseja remover usuário ${item.nome} ?`, async result => {
          if (result) {
            try {
              this.loading = true
              await usuarioService.delete(item.id)
              this.getAll(1, '')
            } catch (error) {
              showError(error)
            } finally {
              this.loading = false
            }
          }
        })
      }
    },
    editItem (item) {
      var ret = retPermissao('Usuários', 'alterar')
      if (ret === true) {
        this.$router.push(`/usuarios/editar/${item.id}`)
      }
    },
    onNewButtonClick () {
      var ret = retPermissao('Usuários', 'incluir')
      if (ret === true) {
        this.$router.push(`/usuarios/criar`)
      }
    }
  }
}
</script>
